import React, { useEffect, useRef, useState } from "react"
import { Alert, Button } from "reactstrap"
import { useSelector } from "react-redux"
import usePhaseContext from "./usePhaseContext"
import usePhaseOperation, { phaseMessage } from "./usePhaseOperation"
import PhaseActionDialog from "./PhaseActionDialog"
import "./phases.scss"

export default function PhaseDrawActions({ eventId, competitionId, onSaved }) {
  const { data, error, loading, reload } = usePhaseContext(eventId, competitionId)
  const phase = data?.phases?.[0]
  const user = useSelector(state => state.session?.userDetails)
  const operation = usePhaseOperation({ eventId, competitionId, phaseId: phase?._id, userId: user?.id || user?._id })
  const [action, setAction] = useState(null)
  const completed = useRef(null)
  useEffect(() => {
    if (operation.status === "saved" && completed.current !== operation.operation.operationId) {
      completed.current = operation.operation.operationId
      setAction(null)
      reload()
      onSaved()
    }
  }, [operation.status, operation.operation, onSaved, reload])
  if (loading) return <span role="status">Loading phase actions…</span>
  if (error) return <Alert color="danger">Phase actions could not be loaded. <Button color="link" onClick={reload}>Retry phase actions</Button></Alert>
  return <div>
    <div className="d-flex flex-wrap mb-3" style={{ gap: 8 }}>
      {['generate', 'reset'].map(value => <Button key={value} color={value === "reset" ? "light" : "primary"}
        disabled={operation.pending || !phase?.permissions?.[value]?.allowed} onClick={() => setAction(value)}>{value === "reset" ? "Reset Phase" : "Generate Phase"}</Button>)}
    </div>
    {phase?.permissions?.generate?.reason && <p className="text-muted">{phaseMessage(phase.permissions.generate.reason)}</p>}
    {operation.pending && <Alert color="info">Awaiting phase confirmation.{operation.message && <> {operation.message}</>} <Button color="link" onClick={operation.recover}>Check result</Button></Alert>}
    {!action && operation.status === "error" && operation.message && <Alert color="danger">{operation.message}</Alert>}
    {action && <PhaseActionDialog eventId={eventId} competitionId={competitionId} phaseId={phase._id} action={action}
      pending={operation.pending} onRecover={operation.recover} message={operation.message} onClose={() => setAction(null)}
      onConfirm={(preview, confirmation) => operation.save(action, preview.revision, undefined, confirmation)} />}
  </div>
}
